var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 998",
    d: "M12.3333 6.308C12.3333 9.50765 9.69244 12.116 6.41667 12.116C3.1409 12.116 0.5 9.50765 0.5 6.308C0.5 3.10835 3.1409 0.5 6.41667 0.5C9.69244 0.5 12.3333 3.10835 12.3333 6.308Z",
    fill: "white",
    stroke: "#21CAE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.03802 6.74398L8.2306 7.91636L8.05465 8.08933L6.8499 6.90497L6.49938 6.56039L6.14885 6.90497L4.9441 8.08933L4.76816 7.91636L5.96073 6.74398L6.32343 6.38742L5.96073 6.03086L4.76816 4.85848L4.9441 4.68552L6.14885 5.86987L6.49938 6.21446L6.8499 5.86987L8.05465 4.68552L8.2306 4.85848L7.03802 6.03086L6.67532 6.38742L7.03802 6.74398Z",
    fill: "#21CAE7",
    stroke: "#21CAE7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose3);
export default __webpack_public_path__ + "static/media/close3.dffeb6bb39e7cd75728abb84988b4a73.svg";
export { ForwardRef as ReactComponent };